import { render, staticRenderFns } from "./Rulex.vue?vue&type=template&id=0fb92b70&scoped=true"
import script from "./Rulex.vue?vue&type=script&lang=js"
export * from "./Rulex.vue?vue&type=script&lang=js"
import style0 from "./Rulex.vue?vue&type=style&index=0&id=0fb92b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb92b70",
  null
  
)

export default component.exports